import type { ReactNode } from 'react';
import { Icon, type IconName } from '@/components/foundations';

/** Seção do painel de detalhes (`.dsec`) com ícone no título. */
export function DrawerSection({ icon, title, children }: { icon: IconName; title: ReactNode; children?: ReactNode }) {
  return (
    <section className="dsec">
      <h3><Icon name={icon} />{title}</h3>
      {children}
    </section>
  );
}
